import AnalyticsHelper from '../../utils/analytics-helper.js';
import Loader from '../modules/loader.js';
import Form from '../../form_builder_2/form.js';
import SelectedDealer from '../modules/selected-dealer.js';
import SelectedModel from '../modules/selected-model.js';
import SelectedAppointment from '../modules/selected-appointment';
import { getProductDivision } from '../../utils/dom.js';

export default class FormView {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.batd-form');
        this.back = this.el.querySelector('.back-link');
        this.modelName = this.el.querySelector('#model-name-change');
        this.dealerName = this.el.querySelector('#dealer-name-change');
        this.headings = this.el.querySelectorAll('.batd-tab-heading');
        this.callbacks = {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
            onUpdate: this.onUpdate.bind(this),
        };
        this.form = new Form(this.el.querySelector('.form_builder'), this.callbacks);
        this.dealer = new SelectedDealer(this, this.router);
        this.model = new SelectedModel(this, this.router);
        this.appointment = new SelectedAppointment(this, this.router);
        this.productDivision = getProductDivision();
        this.init();
        this.bind();
    }

    init() {
        if (HONDA.MyAccount2) {
            HONDA.MyAccount2.addEventListener('expires', () => this.showModal());
        }
    }

    bind() {
        const backToResults = (e) => {
            e.preventDefault();
            this.calendarWarpper = this.form?.el.querySelector('.calendar_wrapper');
            if (this.calendarWarpper?.classList.contains('active')) {
                this.calendarWarpper.classList.remove('active');
            }
            this.router.update('search');
            window.scrollTo(0, 0);
        };
        this.back.addEventListener('click', backToResults);
        this.dealerName.addEventListener('click', backToResults);
        this.modelName.addEventListener('click', backToResults);

        this.headings.forEach((t) => t.addEventListener('click', (e) => {
            e.preventDefault();
            this.headings.forEach((h) => h.parentNode.classList.remove('active'));
            e.currentTarget.parentNode.classList.add('active');
        }));
    }

    onSuccess() {
        this.router.update('confirm');

        const productModel = this.getProductModel();

        if (productModel && this.productDivision) {
            const obj = {
                [this.productDivision]: {
                    lastActivity: {
                        testDrive: productModel,
                    },
                    modelActivity: {
                        [productModel]: {
                            testDrive: true,
                        },
                    },
                },
            };

            HONDA.UserContext?.setData(obj);
        }

        if (HONDA.MyAccount2) {
            HONDA.MyAccount2.client.flushCache('test-drives');
        }
    }

    getProductModel() {
        return this.router.params.get(this.router.data.param);
    }

    onError() {
        this.form.showError();
    }

    onUpdate(field, valid) {
        if (!this.updated) {
            this.updated = true;
            AnalyticsHelper.push({
                event: 'Test drive', eventCategory: ' Test drive', eventLabel: field.label, eventAction: 'Form Filling Initiate',
            });
        }
        if (!valid) {
            AnalyticsHelper.push({
                event: 'Test drive', eventCategory: ' Test drive', eventLabel: field.label, eventAction: 'Form Validation Error',
            });
        }
    }

    show() {
        if (!this.router.params.has(this.router.data.param) || !this.router.params.has('dealer')) {
            this.router.update('search');
        } else {
            this.login();
            this.el.classList.remove('hide');
            this.dealer.show();
            this.model.show();
            window.scrollTo(0, 0);
            this.animate();

            AnalyticsHelper.template(this.back, { dealer: this.router.params.get('dealer'), model: this.router.params.get(this.router.data.param) });
            this.headings.forEach((h) => AnalyticsHelper.template(h, { dealer: this.router.params.get('dealer'), model: this.router.params.get(this.router.data.param) }));
            AnalyticsHelper.push(this.headings[0]);
        }
    }

    hide() {
        this.el.classList.add('hide');
    }

    animate() {
        this.el.classList.remove('pre-animation');
        this.el.classList.add('apply-animation');
    }

    login() {
        if (HONDA.MyAccount2 && !HONDA.MyAccount2.isLoggedIn() && !this.modalShown) {
            this.modalShown = true;
            this.showModal();
        }
    }

    showModal() {
        HONDA.MyAccount2.showModal({ guest: true });
    }
}
